import REQUEST from './Request';
import {createQueryString} from "./SharedAPI"
export const submitMeetingForm = async (formData) => {
  return await REQUEST({
    method: "POST",
    url: "feedback/meeting",
    data: formData,
  });
};
export const submitClientFeedback = async (formData) => {
  return await REQUEST({
    method: "POST",
    url: "feedback/client",
    data: formData,
  });
};

export const getMeetingData = async (meetingId) => {
  return await REQUEST({
    method: "GET",
    url: `meeting/${meetingId}`,
  });
};

export const updateMeetingStatus = async (meetingId, status) => {
  return await REQUEST({
    method: "PUT",
    url: `meeting/${meetingId}/status`,
    data: { status },
  });
};

export const getMeetingLocation = async (meetingId) => {
  return await REQUEST({
    method: "GET",
    url: `meeting/${meetingId}/location`,
  });
};

export const getMeetingMedia = async (meetingId) => {
  return await REQUEST({
    method: "GET",
    url: `meeting/${meetingId}/media`,
  });
}; 

export const getUnits = async (data) => {
  console.log(data);
  return await REQUEST({
    method: "GET",
    url: "unit?" + createQueryString(data),
  });
};
export const getProject = async (data) => {
  console.log(data);
  return await REQUEST({
    method: "GET",
    url: "project?" + createQueryString(data),
  });
};